// import css from "./product.module.css";
// import pic from "../../img/autorRespons.png";
// import starLike from "../../svg/starLike.svg";
// import starDontLike from "../../svg/starDontLike.svg";
// import { HandySvg } from "handy-svg";

// export default function Respons({ rewievList }) {
//   const renderStars = (rating = 0) => {
//     const normalizedRating = Math.max(0, Math.min(5, Number(rating) || 0));

//     return Array.from({ length: 5 }).map((_, index) => (
//       <HandySvg
//         key={index}
//         src={index < normalizedRating ? starLike : starDontLike}
//         className={css.starStyle}
//         width="23"
//         height="22"
//       />
//     ));
//   };

//   return (
//     <div className={css.responsWrap}>
//       <div className={css.responsWrapSmall}>
//         <h1 className={css.h1Response}>Відгуки</h1>

//         {rewievList
//           .filter((review) => review.visible !== false)
//           .map((el) => (
//             <div key={el.uid || el.id} className={css.respons}>
//               <div className={css.responsAuthPic}>
//                 <img
//                   src={el.autorPic || pic}
//                   className={css.responsAuthPic}
//                   alt={el.nameAutor || "Автор відгуку"}
//                 />
//               </div>

//               <div className={css.responsAuthText}>
//                 <p className={css.autorName}>{el.nameAutor || "Користувач"}</p>

//                 <p className={css.autorRespons}>{el.vidguk}</p>

//                 <div className={css.autorRating}>{renderStars(el.rating)}</div>
//               </div>
//             </div>
//           ))}
//       </div>
//     </div>
//   );
// }
import css from "./product.module.css";
import pic from "../../img/autorRespons.png";
import starLike from "../../svg/starLike.svg";
import starDontLike from "../../svg/starDontLike.svg";
import { HandySvg } from "handy-svg";

export default function Respons({ rewievList }) {
  const renderStars = (rating = 0) => {
    const normalizedRating = Math.max(0, Math.min(5, Number(rating) || 0));

    return Array.from({ length: 5 }).map((_, index) => (
      <HandySvg
        key={index}
        src={index < normalizedRating ? starLike : starDontLike}
        className={css.starStyle}
        width="23"
        height="22"
      />
    ));
  };

  const formatDate = (value) => {
    if (!value) return "";

    try {
      if (typeof value.toDate === "function") {
        return value.toDate().toLocaleDateString("uk-UA");
      }

      if (value instanceof Date) {
        return value.toLocaleDateString("uk-UA");
      }

      return "";
    } catch {
      return "";
    }
  };

  return (
    <div className={css.responsWrap}>
      <div className={css.responsWrapSmall}>
        <h1 className={css.h1Response}>Відгуки</h1>

        {rewievList
          .filter((review) => review.visible !== false)
          .map((el) => {
            const hasAdminReply =
              typeof el.adminReply === "string" &&
              el.adminReply.trim().length > 0;

            return (
              <div key={el.uid || el.id} className={css.respons}>
                <div className={css.responsAuthPic}>
                  <img
                    src={el.autorPic || pic}
                    className={css.responsAuthPic}
                    alt={el.nameAutor || "Автор відгуку"}
                  />
                </div>

                <div className={css.responsAuthText}>
                  <p className={css.autorName}>
                    {el.nameAutor || "Користувач"}
                  </p>

                  <p className={css.autorRespons}>{el.vidguk}</p>

                  <div className={css.autorRating}>
                    {renderStars(el.rating)}
                  </div>

                  {hasAdminReply && (
                    <div className={css.adminReply}>
                      <div className={css.adminReplyHeader}>
                        <p className={css.adminReplyAuthor}>
                          {el.adminReplyAuthor || "Адміністрація магазину"}
                        </p>

                        {el.adminReplyCreatedAt && (
                          <span className={css.adminReplyDate}>
                            {formatDate(el.adminReplyCreatedAt)}
                          </span>
                        )}
                      </div>

                      <p className={css.adminReplyText}>{el.adminReply}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
